<template>
  <b-modal
    id="modal-category"
    :title="title"
    centered
    hide-footer
    size="sm"
    :no-close-on-backdrop="true"
  >
    <b-form @submit.prevent="submit">
      <b-form-group :label="placeholder" label-for="input-value">
        <b-form-input
          id="input-value"
          v-model="fields.name"
          v-validate="{ required: true }"
          type="text"
          :placeholder="placeholder"
          size="lg"
          data-vv-name="Category name"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        v-if="type === 'subcategory'"
        label="Category"
        label-for="category"
      >
        <multiselect
          v-model="fields.parentCategory"
          v-validate="{ required: true }"
          :options="filters"
          :taggable="true"
          label="name"
          placeholder="Select category"
          tag-placeholder="Create new category"
          open-direction="bottom"
          data-vv-name="category"
          @tag="createCategory"
        ></multiselect>
      </b-form-group>

      <b-form-checkbox v-model="fields.visibility.discover" size="sm" class="mb-4" switch
        >Discover Visibility</b-form-checkbox
      >

      <b-row>
        <b-col class="text-right">
          <b-btn variant="danger" @click="deleteCategoryConfirm"
            >Delete {{ type }}</b-btn
          >
          <b-btn variant="primary" type="submit" class="ml-2">Save</b-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapActions, mapState } from "vuex";
import general from "../../../helpers/general";
import DataSettings from "@/helpers/DataSettings";
import _ from "lodash";

export default {
  name: "FilterCategoryModal",
  components: {
    Multiselect
  },
  props: {
    create: {
      type: Boolean,
      required: true
    },
    category: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      fields: {
        name: null,
        parentCategory: null,
        visibility: {
          'all': true,
          'discover': true
        }
      }
    };
  },
  computed: {
    ...mapState({
      filters: state => state.filter.filters,
      discoverCategories: (state) => state.setting.dataSettings.focus.lastQuery
    }),
    type() {
      return this.category && this.category.type === "category"
        ? "category"
        : "subcategory";
    },
    title() {
      return `${this.create ? "Create" : "Edit"} ${this.type}`;
    },
    placeholder() {
      return this.$options.filters.ucFirst(this.type) + " name";
    }
  },
  watch: {
    category(val) {
      console.log(val);
      this.fields.name = val.name;
      this.fields.parentCategory = this.filters.find(
        f => f._id === val.parent_id
      );
      let cindex, sindex = -1;
      if(val.type === "category"){
        cindex = _.findIndex(this.discoverCategories, f => f === val._id);
        this.fields.visibility.discover = cindex>-1? false:true;
        //this.discoverCategories[cindex].visibility?
        //this.discoverCategories[cindex].visibility.discover 
        //: true;
      }
      else{
        cindex = _.findIndex(this.discoverCategories, f => f === val._id);
        //sindex = _.findIndex(this.discoverCategories[cindex].children, f => f._id === val._id);
        this.fields.visibility.discover = cindex>-1? false:true;
        //this.discoverCategories[cindex].children[sindex].visibility?
        //this.discoverCategories[cindex].children[sindex].visibility.discover 
        //: true;
      }
      
    }
  },
  methods: {
    ...mapActions(["deleteFilter", "saveFilter", "loadAnimStart", "loadAnimEnd", "saveLoadingStep"]),
    createCategory(e) {
      this.fields.parentCategory = { name: e };
    },
    submit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$toasted.show(this.$validator.errors.items[0].msg, {
            type: "error"
          });
          return false;
        }

        let data = {
          filter: {
            _id: this.category._id,
            type: this.category.type,
            name: this.fields.name
          }
        };

        if (this.category.type === "subcategory") {
          data.category = this.fields.parentCategory;
        }

        this.saveFilter(data).then(() => {
          this.$bvModal.hide("modal-category");
          this.$toasted.show(general.ucFirst(this.type) + " updated");

          this.fields.name = null;
          this.fields.parentCategory = null;
          this.updateVisibility(data);
        });
      });
    },
    deleteCategoryConfirm() {
      if(this.category.children.length > 0 && _.find(this.category.children, function(o) { return !o.name.includes("_del"); })){
        this.$bvModal.msgBoxConfirm(
          "Category with subcategories or filters can't be deleted normally. Do you want to proceed anyway? This will delete the category and all its children.",
          {
            title: 'Warning',
            size: 'sm',
            okTitle: 'Proceed Anyway',
            cancelTitle: 'Cancel',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
          }
        ).then(value => {
          if (value) {
            this.proceedDeleteCategory();
          }
        });
      }
      else{
        this.$bvModal
        .msgBoxConfirm(
          `Are you sure you want to delete “${this.category.name}”?`,
          this.$confirmOptions
        )
        .then(value => {
          if (value) {
            this.deleteFilter({
              filter: {
                _id: this.category._id
              }
            }).then(() => {
              this.updateVisibilityForDel({
                filter: {
                  _id: this.category._id
                }
              });
              this.$bvModal.hide("modal-category");
              this.$toasted.show(general.ucFirst(this.type) + " deleted");
            });
          }
        });
      }
    },

    proceedDeleteCategory() {
      this.saveLoadingStep("Deleting...");
      this.loadAnimStart();
      // Proceed with deletion even if there are children
      this.deleteFilter({
        filter: {
          _id: this.category._id
        }
      }).then(() => {
        this.updateVisibilityForDel({
          filter: {
            _id: this.category._id
          }
        });
        this.$bvModal.hide("modal-category");
        this.$toasted.show(general.ucFirst(this.type) + " and its children deleted");
        this.saveLoadingStep("Deleted");
        this.loadAnimEnd();
        this.saveLoadingStep("");
      });
    },
    updateVisibilityForDel(data){
      /*const filter = data.filter;
      const settings = DataSettings.getSettings("focus");
      let discoverCats = settings.lastQuery || this.filters;
      if(discoverCats.find((f) => { return f._id === filter._id })){
        let index = _.findIndex(discoverCats, (f) => { return f._id === filter._id; });
        let newSettings = discoverCats;
        newSettings.splice(index, 1);
        DataSettings.setSettings("focus.lastQuery", newSettings);
      }
      else{
        discoverCats.forEach((cat, ci) => {
          if(cat.children.find((f) => { return f._id === filter._id })){
            let index = _.findIndex(cat.children, (f) => { return f._id === filter._id; });
            let newSettings = discoverCats;
            newSettings[ci].children.splice(index, 1);
            DataSettings.setSettings("focus.lastQuery", newSettings);
          }
        });
      }*/
      const settings = DataSettings.getSettings("focus");
      if(settings.lastQuery.includes(data.filter._id)){
        let newSettings = settings.lastQuery;
        const index = _.findIndex(newSettings, data.filter._id);
        newSettings.splice(index, 1);
        DataSettings.setSettings("focus.lastQuery", newSettings);
      }
    },
    updateVisibility(data){
      const settings = DataSettings.getSettings("focus");
      if(!this.fields.visibility.discover){
        if(!settings.lastQuery.includes(data.filter._id)){
          let newSettings = settings.lastQuery;
          newSettings.push(data.filter._id);
          DataSettings.setSettings("focus.lastQuery", newSettings);
        }
      }
      else{
        if(settings.lastQuery.includes(data.filter._id)){
          let newSettings = settings.lastQuery;
          const index = _.findIndex(newSettings, data.filter._id);
          newSettings.splice(index, 1);
          DataSettings.setSettings("focus.lastQuery", newSettings);
        }
      }
      /*
      const filter = data.filter;
      let discoverCats = this.discoverCategories || this.filters;
      if(discoverCats.find((f) => { return f._id === filter._id })){
        let index = _.findIndex(discoverCats, (f) => { return f._id === filter._id; });
        let newSettings = discoverCats;
        newSettings[index].visibility = this.fields.visibility;
        DataSettings.setSettings("focus.lastQuery", newSettings);
      }
      else{
        discoverCats.forEach((cat, ci) => {
          if(cat.children.find((f) => { return f._id === filter._id })){
            let index = _.findIndex(cat.children, (f) => { return f._id === filter._id; });
            let newSettings = discoverCats;
            newSettings[ci].children[index].visibility = this.fields.visibility;
            DataSettings.setSettings("focus.lastQuery", newSettings);
          }
        });
      }
      */
    }
  }
};
</script>
